document.addEventListener('DOMContentLoaded', function() {
  const initBrandIcons = () => {
    var $brandIconsSlider = $(".brand-icons__slider");
    $brandIconsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.brand-icons__logo-nav .brand-icons__logo').eq(currentSlide).removeClass('brand-logo-active');
      $('.brand-icons__logo-nav .brand-icons__logo').eq(nextSlide).addClass('brand-logo-active');
    });
    $brandIconsSlider.on('init', function(event, slick){
      $('.brand-icons__logo-nav .brand-icons__logo').eq(slick.currentSlide).addClass('brand-logo-active');
    });

    $brandIconsSlider.slick({
      mobileFirst: true,
      prevArrow: $('.section-brand-icons .arrow-left'),
      nextArrow: $('.section-brand-icons .arrow-right'),
      responsive: [
        {
          breakpoint: 899,
          settings: {
            arrows: false,
          }
        }
      ]
    });

    $('.brand-icons__logo-nav .brand-icons__logo').click(function(){
      var $el = $(this);
      var goToSlide = parseInt($el.index());
      $(".brand-icons__slider").slick('slickGoTo', goToSlide);
    });
  };

  initBrandIcons();
});